import { ISmartPayTrackingState } from './smart-pay-tracking.types'

let state: ISmartPayTrackingState | null = null

/**
 * Singleton store for Smart Pay form-interaction analytics.
 *
 * The Smart Pay flow only ever has one active instance at a time, so a module
 * singleton (mirroring the static `TrackingService`) is sufficient and keeps
 * the analytics data out of Formik values — which would otherwise leak into the
 * shift API payload via `extractShift`.
 */
export const SmartPayTracking = {
  init({
    initialPayRate,
    smartPayRate,
  }: {
    initialPayRate: number
    smartPayRate: number
  }): void {
    if (state) {
      return
    }

    state = {
      initialPayRate,
      smartPayRate,
      interacted: false,
      lastRateSource: 'unchanged',
    }
  },

  setSmartPayRate(rate: number): void {
    if (state) {
      state.smartPayRate = rate
    }
  },

  markManualChange(): void {
    if (state) {
      state.lastRateSource = 'manual'
    }
  },

  markSmartPayClick(): void {
    if (state) {
      state.interacted = true
      state.lastRateSource = 'smart_pay'
    }
  },

  getState(): ISmartPayTrackingState | null {
    return state
  },

  snapshot(): ISmartPayTrackingState | null {
    return state ? { ...state } : null
  },

  restore(snapshot?: ISmartPayTrackingState | null): void {
    state = snapshot ? { ...snapshot } : null
  },

  reset(): void {
    state = null
  },
}
